import customDropdownsInit from "../dropdowns";
import cursorInit from "../cursor";

(function () {
	function bindFilterEvents() {
		const listingForm = document.querySelector(".js-listingForm");
		const listingFilterItems = listingForm.querySelectorAll(".js-listingFilterItem");

		listingFilterItems.forEach((listingFilterItem) => {
			listingFilterItem.addEventListener("change", function () {
				applyFilter(listingForm);
			});
		});
	}

	function applyFilter(form) {
		var url = form.getAttribute("action");
		var method = form.getAttribute("method");
		var data = new URLSearchParams(new FormData(form)).toString();
		var xhr = new XMLHttpRequest();
		xhr.open(method, url, true);
		xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"); // Send the proper header information along with the request
		xhr.responseType = "json";
		xhr.onload = function () {
			if (xhr.status === 200) {
				var newRelativePathQuery = window.location.pathname;
				if (this.response.querystring) {
					newRelativePathQuery += '?' + this.response.querystring;
				}
				window.history.pushState(null, '', newRelativePathQuery);
				document.querySelector(".js-listingSection").outerHTML = this.response.html;
				bindFilterEvents();
				customDropdownsInit();
				cursorInit();
			} else {
				document.querySelector(".js-listingSection").innerHTML = "Error " + xhr.status + " occurred.";
			}
		};
		xhr.send(data);
	}

	bindFilterEvents();
})();
